import React from "react";
import { formatCurrency } from "util/format";

const ColumnsFooterCashFlow = {
  paid: [
    {
      title: "data",
      dataIndex: "data",
      render: (text, record) => <div>{"Total"}</div>,
    },
    {
      title: "entrada",
      dataIndex: "entrada",
    },
    {
      title: "saida",
      dataIndex: "saida",
    },
    {
      title: "amount",
      dataIndex: "amount",
      render: (text) => {
        return <div style={{ float: "right" }}>{formatCurrency(text)}</div>;
      },
    },
  ],
  receive: [
    {
      title: "vencimento",
      dataIndex: "vencimento",
      render: (text, record) => <div>{"Total"}</div>,
    },
    {
      title: "forncedor",
      dataIndex: "forncedor",
    },
    {
      title: "categoria",
      dataIndex: "categoria",
    },
    {
      title: "Entrada",
      dataIndex: "amount",
      render: (text) => {
        return <div style={{ float: "right" }}>{formatCurrency(text)}</div>;
      },
    },
  ],

  cashFlow: [
    {
      title: "total",
      dataIndex: "total",
      render: (text, record) => (
        <div style={{ marginLeft: "36px" }}>{"Total"}</div>
      ),
    },
    {
      title: "Entrada",
      dataIndex: "receive",
      render: (text) => {
        return formatCurrency(text);
      },
    },
    {
      title: "Saida",
      dataIndex: "paid",
      render: (text) => {
        return formatCurrency(text);
      },
    },
    {
      title: "Saldo Final",
      dataIndex: "amount",
      render: (text) => {
        return formatCurrency(text);
      },
    },
  ],
  cashFlowDaily: [
    {
      title: "data",
      dataIndex: "data",
      render: (text, record) => <div>{"Total"}</div>,
    },
    {
      title: "entrada",
      dataIndex: "entrada",
    },
    {
      title: "saida",
      dataIndex: "saida",
    },
    {
      title: "amount",
      dataIndex: "amount",
      render: (text) => {
        return <div style={{ float: "right" }}>{formatCurrency(text)}</div>;
      },
    },
  ],
};

export default ColumnsFooterCashFlow;
